module.exports = "<template>\n    <!-- Empty placeholder -->\n</template>\n";